"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importStar(require("react"));
const navigation_context_1 = require("../../composite/navigation/navigation-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const link_styles_1 = require("./link-styles");
function Link({ to, replace, state, children, }) {
    const { navigate } = react_1.useContext(navigation_context_1.NavigationContext);
    const classes = link_styles_1.useStyles();
    const handleClick = event_callback_hook_1.useEventCallback(() => {
        navigate(to, replace, state);
    });
    return (react_1.default.createElement("a", { className: classes.root, onClick: handleClick }, children));
}
exports.Link = Link;
//# sourceMappingURL=link.js.map